module.exports = function() {
    console.error('"getAuthorizationKey" is deprecated. Please use "requestAuthorizationKey" in the future.');
    this.requestAuthorizationKey();
};
